var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ErrorState',{attrs:{"insides":['badrequest_item', 'badrequest_back'],"subtitle":"Tivemos um problema no servidor.\n            Por favor, tente novamente em alguns instantes :)"}})}
var staticRenderFns = []

export { render, staticRenderFns }